import { Button } from '@/components/ui/button';
import { ArrowRight, Users, Target, Lightbulb, ChevronDown } from 'lucide-react';
import ContactLink from '@/components/ContactLink';

const Hero = () => {
  return (
    <section id="home" className="relative min-h-[85vh] flex items-center bg-background overflow-hidden pt-24 pb-20">
      <div className="container-max relative z-10">
        <div className="max-w-4xl">
          {/* Main Heading */}
          <div className="fade-in-up-quick">
            <h1 id="main-content" tabIndex={-1} className="scroll-mt-20 text-5xl md:text-7xl lg:text-8xl font-bold mb-6 leading-none tracking-tight">
              <span className="block text-primary">COMMITTED TO</span>
              <span className="block text-primary">EXCELLENCE</span>
            </h1>
          </div>

          {/* Subheading */}
          <div className="fade-in-up-quick">
            <p className="text-xl md:text-2xl text-muted-foreground mb-8 max-w-3xl leading-relaxed">
              AI-native engineering firm specializing in enterprise services, domain-specific solutions, and high-performance infrastructure from strategy through deployment. We build innovative systems that drive measurable results for commercial enterprises and government agencies.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="fade-in-up-quick flex flex-col sm:flex-row gap-4 mb-12">
            <Button asChild size="lg" className="btn-hero group">
              <a href="#services">
                Explore Our Services
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
              </a>
            </Button>
            {/* variant="outline" — a SOLID button (bg-background) that reads as
                a distinct colour against the hero, not the transparent
                btn-outline-hero, which is muted-grey-on-transparent and
                recedes. size="lg" is h-11, matching what .btn-hero applies to
                the left button, so the pair is the same height without the two
                sizing systems conflicting. */}
            <Button variant="outline" size="lg" className="px-8 rounded-lg" asChild>
              <ContactLink>
                Contact Us
              </ContactLink>
            </Button>
          </div>

          {/* Key Points */}
          <div className="fade-in-up-quick grid grid-cols-1 md:grid-cols-3 gap-6 max-w-2xl">
            <div className="flex items-center justify-center space-x-3">
              <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center">
                <Users className="h-5 w-5 text-primary" />
              </div>
              <span className="font-medium text-foreground">People</span>
            </div>
            <div className="flex items-center justify-center space-x-3">
              <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center">
                <Target className="h-5 w-5 text-primary" />
              </div>
              <span className="font-medium text-foreground">Mission</span>
            </div>
            <div className="flex items-center justify-center space-x-3">
              <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center">
                <Lightbulb className="h-5 w-5 text-primary" />
              </div>
              <span className="font-medium text-foreground">Purpose</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <a href="#services" aria-label="Explore our services" className="absolute bottom-10 left-1/2 -translate-x-1/2">
        <ChevronDown className="homepage-chevron h-8 w-8 text-muted-foreground" />
      </a>
    </section>
  );
};

export default Hero;
